import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { EmployeePaymentsDataDto } from "./employee-payments-data-dto";

export class EmployeePaymentsStatusResponse extends GlobalResponseObject{
    data?: EmployeePaymentsDataDto[];
}

